var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorkspaceBusinesscomponent = function SvgWorkspaceBusinesscomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5 10.5h-6v-3l-3-3h-6l-3 3v3h-6c-1.65 0-3 1.35-3 3V18c0 1.665 1.335 3 3 3h9v-3h6v3h9c1.65 0 3-1.35 3-3v-4.5c0-1.65-1.35-3-3-3ZM15.5 24v-1.5H5.015L5 28.5c0 1.665 1.335 3 3 3h21c1.665 0 3-1.335 3-3v-6H21.5V24h-6Zm0-13.5h6v-3h-6v3Z",
    fill: "#CC61B5"
  })));
};
export default SvgWorkspaceBusinesscomponent;